import { createAction, props } from '@ngrx/store';
import { ICheckRegisterRequiredRequest, ICheckRegisterRequiredResponse } from '../../../core/models/check-registration.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

// * -------------------  // * CHECK ------------------- * /
export const checkRegisterRequiredRequest = createAction(
  '[CheckIfRegistered] check register required request',
  props<{ request: ICheckRegisterRequiredRequest }>()
);

export const checkRegisterRequiredSuccess = createAction(
  '[CheckIfRegistered] check register required response',
  props<{ response: ICheckRegisterRequiredResponse }>()
);

export const checkRegisterRequiredFailure = createAction(
  '[CheckIfRegistered] check register required failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
